import { Dropdown } from 'src/app/shared/models/dropdown.model';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-multiselectable-dropdown',
  templateUrl: './multiselectable-dropdown.component.html',
  styleUrls: ['./multiselectable-dropdown.component.scss']
})
export class MultiselectableDropdownComponent implements OnInit, OnChanges {
  @Input() items: Dropdown[];
  @Input() title: string;
  @Input() clearAll: any;
  @Input() selectedItem: any;
  @Input() labelName: string;
  @Input() disableItems = false;
  @Output() onSelect = new EventEmitter<any>();

  public open = false;
  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.clearAll && changes.clearAll.currentValue) {
      if (this.items) {
        this.items.forEach((item) => delete item.checked);
      }
    }

    if (changes.items && changes.items.currentValue) {
      this.items.forEach(element => {
          element.checked = false;
      });
    }

    if(changes.selectedItem && changes.selectedItem.currentValue) {
      const data = this.selectedItem.split(',');
      this.items.forEach(element => {
        if(data.includes(element.dropdownID.toString())) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      });
    }
  }

  ngOnInit(): void {
  }

  checkValue(): void {
    const selectedItems = this.items.filter((item: Dropdown) => item.checked);
    const filters = selectedItems.map((item: Dropdown) => item.dropdownID);
    this.onSelect.emit(filters);
  }

}
